import { goToCreateCompanyForms } from '@rd-web-markets/market/dist/util/new_company_page/goToCreateCompanyForm';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const CreateCompanyBasedOnSearchTerm = ({ lastSearchedTerm = '', companies = [], user}) => {
  const { t } = useTranslation();
  const history = useHistory();

  if (!lastSearchedTerm.length || !!companies.length) return null;

  return (
    <div className='d-flex flex-column align-items-center'>
      <p className='text-center'>{t('no_company_found_do_you_want_to_create_with_searched_name')}</p>

      <p className='fw-bold text-center'>{lastSearchedTerm}</p>

      <Button style={{ width: '100px' }} variant="primary" onClick={() => goToCreateCompanyForms({ name: lastSearchedTerm, id_in_provider_system: '' }, history, user)}>
        {t('yes')}
      </Button>


    </div >
  )
}

export default CreateCompanyBasedOnSearchTerm;
